<template>
  <div class="defaulth-header">
    <div class="defaulth-header-nav">
      <div class="defaulth-header-box">
        <div class="left">
          <img v-if="infoObj.footerLogo" @click="toIndex" :src="infoObj.footerLogo" />
        </div>
        <div class="right">
          <div class="item">
            <div @click="toIndex">
              <img src="../../static/images/icon00.png" :class="navIndex == index ? 'nav-active' : ''" />
              首页
            </div>
          </div>
          <div class="item" v-for="(item, index) in list" :key="index" @click="toPage(index)">
            <div v-if="item.menuShow == 1">
              <img src="../../static/images/icon00.png" :class="navIndex == index ? 'nav-active' : ''" />
              {{ item.menuName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {menuList} from '@/api/xx-index'
import {infoList} from '@/api/index'
export default {
  props: ['navIndex'],
  data() {
    return {
      list: [],
      infoObj: {}
    }
  },
  created() {
    this.menuListx()
  },
  methods: {
    menuListx() {
      menuList({deptId: 112}).then(res => {
        console.log(res)
        this.list = res
      })
      //公司基本信息数据
      infoList({deptId: 112}).then(res => {
        // console.log('公司基本信息', res)
        this.infoObj = res
      })
    },
    //去首页
    toIndex() {
      this.$router.push('/')
    },
    //页面跳转
    toPage(index) {
      this.navIndex = index
      this.$router.push(this.list[index].template.templateUrl + '?id=' + this.list[index].id)
    }
  }
}
</script>

<style></style>
